import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clear-form"
export default class extends Controller {
  connect() {
    const clearFormButton = document.querySelector('a#clear-form-button');
    clearFormButton.addEventListener('click', function() {
      const form = document.querySelector('form.clearable-form');
      form.reset();
    });
  }
}
